import type { JWTContextUser } from '@savvy/deprecated-shared/api/user-api';

export function canViewAdminFeatures(user: JWTContextUser | undefined): boolean {
  return isSavvyAdmin(user) || user?.role === 'CSA' || user?.role === 'READ_ONLY_ADMIN'; // TODO: should CSA be removed?
}

/**
 * CSA review banners surface account-confirmation review conditions. Client-services admins hold
 * ADMIN_CSA (most CSAs) or CSA; product-team admins hold ADMIN — all three see the banner.
 */
export function canSeeCsaReviewBanner(user: JWTContextUser | null | undefined) {
  if (user === null || user === undefined) {
    return false;
  }

  return user.role === 'CSA' || user.role === 'ADMIN_CSA' || user.role === 'ADMIN';
}

/**
 * Roles AuthGuard's forAdmin admits — narrower than `admin_or_read_only_admin?`, which also covers
 * `csa_system_admin` (absent from the `UserRole` GraphQL enum). Gate links *into* an admin page
 * here; gate the data itself at the API.
 */
export function canOpenAdminOnlyPage(user: JWTContextUser | null | undefined) {
  if (user === null || user === undefined) {
    return false;
  }

  return user.role === 'ADMIN' || user.role === 'ADMIN_CSA' || user.role === 'READ_ONLY_ADMIN';
}

/** Savvy platform admins only — excludes advisor CSAs and read-only admins. */
export function isSavvyAdmin(user: JWTContextUser | undefined) {
  if (user === null || user === undefined) {
    return false;
  }

  return user.role === 'ADMIN' || user.role === 'ADMIN_CSA';
}
